import React from "react";

import { Flex, Text, TransparentButton, Price } from "flicket-ui";

import { Select } from "~components";
import { Icon } from "~components/common/Icon";
import { LineItemType } from "~graphql/sdk";
import {
  EditModalLineItem,
  EditModalTicketType,
  EditModalZone,
} from "./EditModalContent";

type EditListItemProps = {
  lineItem: EditModalLineItem;
  onChange: (
    lineItem: EditModalLineItem,
    update: Partial<EditModalLineItem>
  ) => void;
  addToRelease: (ticket: any) => void;
  currentZone: EditModalZone;
  releaseLineItems: any[];
  allTicketTypes: EditModalTicketType[];
  isMultiBuy: any[];
};

interface SimpleTicketType {
  id: string;
  name?: string;
  price?: number;
  isActive?: boolean;
}

export const EditListItem = ({
  lineItem,
  onChange,
  releaseLineItems,
  addToRelease,
  currentZone,
  allTicketTypes,
  isMultiBuy,
}: EditListItemProps) => {
  const isToBeReleased = releaseLineItems.find((r) => r.id === lineItem.id);

  const ticketTypeId = lineItem?.membershipType?.id ?? lineItem.ticketType?.id;
  const ticketTypes = ((): SimpleTicketType[] | undefined => {
    if (currentZone?.ticketTypes) {
      return currentZone.ticketTypes.map((t) => ({
        id: t.id,
        name: t.name,
      }));
    } else if (currentZone?.membershipTypes) {
      return currentZone.membershipTypes.map((t) => ({
        id: t.membershipTypeId,
        isActive: t.isActive,
        price: t.price,
      }));
    }
    return undefined;
  })();

  const ticketTypeOptions = ticketTypes
    ?.filter((t) => t?.isActive)
    ?.map((t) => ({
      label: allTicketTypes?.find((type) => type.id === t?.id)?.name,
      value: t?.id,
    }));

  const price = ticketTypes?.find(
    (ticketType) => ticketTypeId === ticketType?.id
  )?.price;

  const promo =
    isMultiBuy &&
    /* @ts-expect-error this should be fixed soon**/
    (isMultiBuy.type === "getting" || isMultiBuy.giftedQty > 0) ? (
      <Text ml="1/4">
        Multibuy promotion applied
        {/* @ts-expect-error this should be fixed soon */}
        <Price price={price * (isMultiBuy?.giftedQty ?? 1)} />
      </Text>
    ) : undefined;

  const handleChange = (value) => {
    const update = {
      [lineItem.membershipType ? "membershipType" : "ticketType"]: {
        id: value,
        name: allTicketTypes?.find((type) => type.id === value)?.name ?? "-",
      },
    };

    return onChange(lineItem, update);
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      key={`key-${ticketTypeId}-${lineItem.id}`}
    >
      <Flex
        alignItems="center"
        textDecoration={isToBeReleased ? "line-through" : "none"}
        onClick={() => addToRelease(lineItem)}
        cursor="pointer"
      >
        <Text opacity={isToBeReleased ? ".6" : 1}>
          ({lineItem?.quantity}) {lineItem?.name}
          {promo && (
            <Text as="span">
              <br /> {promo}
            </Text>
          )}
        </Text>
        <TransparentButton ml={2}>
          {isToBeReleased ? (
            <>
              <Icon icon="warning-circle" />
            </>
          ) : (
            <Icon icon="cross" />
          )}
        </TransparentButton>
      </Flex>
      {lineItem?.type !== LineItemType.Addon && currentZone?.isActive && (
        <Select
          disabled={isToBeReleased}
          onChange={handleChange}
          defaultValue={ticketTypeId}
          options={ticketTypeOptions}
          flexBasis="calc(100% - 75%)"
          ml={2}
          mr="1/4"
        />
      )}
    </Flex>
  );
};
